<div class="flex flex-col content-wrapper items-stretch border-opacity-20 zen-main-container" [ngClass]="globalService.innerRoute?'inner':'full'">
  <ng-content></ng-content>
</div>
